export const environment = {
  production: false,
  staging: true,
  appstraxServicesUrl: 'https://staging-services.enterprise.appstrax.tech/',
  appstraxServicesApiKey: 'JfBfFjbEuaz0nqo5CFM6WWlL4vOOBK',
  machineApiUrl: 'https://staging-api.enterprise.appstrax.tech',
}; 